import React from "react";
import { Swipeable } from 'react-swipeable'
import PropTypes from 'prop-types';
import {
    CarouselContainer,
    CarouselSlot,
    PREV,
    NEXT
} from "./components";

const getOrder = ({ index, pos, numItems }) => {
    return index - pos < 0 ? numItems - Math.abs(index - pos) : index - pos;
};
const initialState = { pos: 0, sliding: false, dir: NEXT };

export default function Carousel(props) {

    const [state, dispatch] = React.useReducer(reducer, initialState);

    const slide = dir => {
        dispatch({ type: dir, numItems: props.numItems });
        setTimeout(() => {
            dispatch({ type: "stopSliding" });
        }, 50);
    };

    const config = {
        onSwipedLeft: () => slide(NEXT),
        onSwipedRight: () => slide(PREV),
        preventDefaultTouchmoveEvent: true,
        trackMouse: true
    };

    return (
        <Swipeable {...config} style={props.transform ? { transform: `translateX(${props.transform})` } : { transform: "translateX(10%)" }}>
            <CarouselContainer dir={state.dir} sliding={state.sliding}>
                {props.items.map((item, index) => (
                    <CarouselSlot
                        key={index}
                        order={getOrder({ index: index, pos: state.pos, numItems: props.numItems })}
                    >
                        {item}
                    </CarouselSlot>
                ))}
            </CarouselContainer>
        </Swipeable>
    );
};

function reducer(state, { type, numItems }) {
    switch (type) {
        case "reset":
            return initialState;
        case PREV:
            return {
                ...state,
                dir: PREV,
                sliding: true,
                pos: state.pos === 0 ? numItems - 1 : state.pos - 1
            };
        case NEXT:
            return {
                ...state,
                dir: NEXT,
                sliding: true,
                pos: state.pos === numItems - 1 ? 0 : state.pos + 1
            };
        case "stopSliding":
            return { ...state, sliding: false };
        default:
            return state;
    }
}

Carousel.propTypes = {
    items: PropTypes.array.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Widgets/SwipeCarousel/Carousel.js